module.exports = __webpack_public_path__ + "static/assets/f6b3e568c54b795c9beed15151ce443a.gif";